/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { PersonVoice24Regular, Textbox24Regular } from '@fluentui/react-icons';
import { IPivotItemProps, IPivotProps, Pivot, PivotItem } from '@fluentui/react/lib/Pivot';
import { Stack } from '@fluentui/react/lib/Stack';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { DemoTypePivotKeys } from 'src/languageStudio/core/types';

const messages = defineMessages({
    documents: { id: 'languageStudio.demoTypePivot.documents', defaultMessage: 'Documents' },
    conversation: { id: 'languageStudio.demoTypePivot.conversation', defaultMessage: 'Conversation' }
});

const getPivotItemIcon = (pivotType: DemoTypePivotKeys) => {
    switch (pivotType) {
        case 'conversation':
            return <PersonVoice24Regular />;
        case 'document':
            return <Textbox24Regular />;
        default:
            return null;
    }
};

export const DemoTypePivot = (props: IPivotProps & { selectedKey: DemoTypePivotKeys }) => {
    const { localize } = useLocalization();

    const onRenderLinkItem = (itemProps: IPivotItemProps, itemDefaultRenderer: (q?: IPivotItemProps) => JSX.Element) => (
        <Stack horizontal verticalAlign="center">
            {getPivotItemIcon(itemProps.itemKey as DemoTypePivotKeys)}
            {itemDefaultRenderer(itemProps)}
        </Stack>
    );

    return (
        <Pivot {...props} selectedKey={props.selectedKey}>
            <PivotItem itemKey="document" onRenderItemLink={onRenderLinkItem} headerText={localize(messages.documents)} />
            <PivotItem itemKey="conversation" onRenderItemLink={onRenderLinkItem} headerText={localize(messages.conversation)} />
        </Pivot>
    );
};
